module.exports = {
  __depends__: [
    require(139)
  ],
  __init__: [ 'labelSupport'],
  labelSupport: [ 'type', require(111) ]
};
